import { render, staticRenderFns } from "./Alertas.vue?vue&type=template&id=5fb5f71c&"
import script from "./Alertas.vue?vue&type=script&lang=js&"
export * from "./Alertas.vue?vue&type=script&lang=js&"
import style0 from "./Alertas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Alertas.vue"
export default component.exports